export default __webpack_public_path__ + "static/media/showcase-settlements.8fe8f557.jpg";